// for Android and iOS firebase log events
// https://firebase.google.com/docs/analytics/ios/webview
// 2018.08.29 Wildmud Aleiku

export default new class WFirebase {
	
	logEvent(name, params) {
	  if (!name) {
	    return;
	  }

	  if (window.AnalyticsWebInterface) {
	    // Call Android interface
	    window.AnalyticsWebInterface.logEvent(name, JSON.stringify(params));
	  } else if (window.webkit
	      && window.webkit.messageHandlers
	      && window.webkit.messageHandlers.firebase) {
	    // Call iOS WKMessageHandlers interface
	    let message = {
	      command: 'logEvent',
	      name: name,
	      parameters: params
	    };
	    window.webkit.messageHandlers.firebase.postMessage(message);
	  } 
	  else if (window.WWebViewHandler) {
	    // Call iOS WWebViewHandler interface
	    let message = {
	      command: 'logEvent',
	      name: name,
	      parameters: params
	    };
	    window.WWebViewHandler.postMessage(message);
	  } else {
	    // No Android or iOS interface found
	    console.log("No native APIs found.");
	  }
	}

}()


// WEBPACK FOOTER //
// ./src/helpers/firebase.js